import { useState, useEffect, useContext } from 'react'
import { LocalVendedorDTO } from '../../../dto/LocalDTO'
import { LocalContext } from '../../AdminLocal/context/local.context'

type Feature = {
  id: number
  nombre: string
  activo: boolean
}

const ACCOUNT_TYPES = {
  basic: 'Cuenta <b>BÁSICA</b>',
  premium: 'Cuenta <b>PREMIUM</b>'
}

const CONFIG = {
  maxPhotos: 'maxFotosXPublicacion',
  maxPublicaciones: 'maxPublicaciones',
  precioDto: 'precioConDto',
  ofrecerPremium: 'premium_ofrecerPremium',
  whppContratos: 'whatsappContratos',
  show_impo: 'integraciones_importacion_enabled',
  show_expo: 'integraciones_exportacion_enabled',
  integraciones: 'integraciones_tiendas_enabled',
  historiasBanner: 'historias_banner_imgurl',
  historiasLink: 'historias_banner_link',
  subeVideo: 'video_max_cantidad',
  maxSizeVideo: 'video_max_size_mb',
  maxDurationVideo: 'video_max_duration_seg',
  estadisticasEnabled: 'estadisticas_avanzadas_enabled',
  whppSoporte: 'whatsappSoporte'
}

const useLocal = (code: string) => {
  const { codLocal, setCodLocal, local, loading, fetchData } = useContext(LocalContext)
  const [idLocal, setIdLocal] = useState<number>(0)
  const [localConfig, setLocalConfig] = useState<any>({
    isRetailer: false,
    isWholeSaler: false,
    isPremium: false,
    maxPhotos: 0,
    maxPublicaciones: 0,
    esMinorista: false,
    precioDto: false,
    ofrecerPremium: false,
    usaSku: false,
    shareLink: '',
    shareLinkMinorista: '',
    whppContratos: '',
    showImpoExpo: false,
    showIntegraciones: false,
    historiasBanner: '',
    historiasLink: '',
    subeVideo: '0',
    maxSizeVideo: '',
    maxDurationVideo: '',
    estadisticasEnabled: false,
    whppSoporte: ''
  })

  const processData = () => {
    const maxPhotos = local.config?.find((conf: any) => conf.name === CONFIG.maxPhotos).value
    const maxOfertas = local.config?.find((conf: any) => conf.name === CONFIG.maxPublicaciones).value
    const precioAnterior = local.config?.find((conf: any) => conf.name === CONFIG.precioDto).value
    const showPre = local.config?.find((conf: any) => conf.name === CONFIG.ofrecerPremium).value
    const whatsappContratos = local.config?.find((conf: any) => conf.name === CONFIG.whppContratos).value
    const retailer = local.caracteristicasList?.find((feat: Feature) => feat.id === 2)?.activo
    const wholesaler = local.caracteristicasList?.find((feat: Feature) => feat.id === 1)?.activo
    const historiasBanner = local.config?.find((conf: any) => conf.name === CONFIG.historiasBanner).value
    const historiasLink = local.config?.find((conf: any) => conf.name === CONFIG.historiasLink).value
    const minorista = local.caracteristicasList?.find((feat: Feature) =>
      feat.nombre.toLowerCase().includes('minorista')
    )?.activo
    const sku = local.caracteristicasList?.find((feat: Feature) => feat.id === 11)
    const showImpo = local.config?.find((c) => c.name === CONFIG.show_impo)?.value === 'true'
    const showExpo = local.config?.find((c) => c.name === CONFIG.show_expo)?.value === 'true'
    const subeVideo = Number(local.config?.find((c) => c.name === CONFIG.subeVideo)?.value) > 0
    const maxSizeVideo = local.config?.find((c) => c.name === CONFIG.maxSizeVideo)?.value
    const maxDurationVideo = local.config?.find((c) => c.name === CONFIG.maxDurationVideo)?.value
    const estadisticasPremium = local.config?.find((c) => c.name === CONFIG.estadisticasEnabled)?.value === 'true'
    const whppSoporte = local.config?.find((c) => c.name === CONFIG.whppSoporte)?.value

    const showIntegraciones = local.config?.find((c) => c.name === CONFIG.integraciones)?.value === 'true'
    setIdLocal(local.idLocal)
    setLocalConfig({
      ...localConfig,
      isRetailer: retailer,
      isPremium: local.cuentaTipoNombre === ACCOUNT_TYPES.premium,
      isWholeSaler: wholesaler,
      maxPhotos: parseInt(maxPhotos),
      maxPublicaciones: parseInt(maxOfertas),
      esMinorista: minorista,
      precioDto: precioAnterior == 'true',
      ofrecerPremium: showPre === 'true',
      usaSku: sku,
      shareLink: local.shareLink,
      shareLinkMinorista: local.shareLinkMinorista, //chusmear
      whppContratos: whatsappContratos,
      showImpo,
      showExpo,
      showIntegraciones,
      historiasBanner: historiasBanner,
      historiasLink: historiasLink,
      subeVideo: subeVideo,
      maxSizeVideo: maxSizeVideo,
      maxDurationVideo: maxDurationVideo,
      estadisticasEnabled: estadisticasPremium,
      whppSoporte: whppSoporte
    })
  }

  useEffect(() => {
    if (!local) return
    processData()
  }, [local])

  useEffect(() => {
    if (!code || code === codLocal) return
    setCodLocal(code)
  }, [code])

  return {
    fetchData,
    local: local,
    loading: loading,
    idLocal: idLocal,
    retail: localConfig.isRetailer,
    wholesaler: localConfig.isWholeSaler,
    premium: localConfig.isPremium,
    maxPhotos: localConfig.maxPhotos,
    maxPublicaciones: localConfig.maxPublicaciones,
    esMinorista: localConfig.esMinorista,
    precioDto: localConfig.precioDto,
    ofrecerPremium: localConfig.ofrecerPremium,
    usaSku: localConfig.usaSku,
    shareLink: localConfig.shareLink,
    shareLinkMinorista: localConfig.shareLinkMinorista,
    whppContratos: localConfig.whppContratos,
    showImpo: localConfig.showImpo,
    showExpo: localConfig.showExpo,
    showIntegraciones: localConfig.showIntegraciones,
    historiasBanner: localConfig.historiasBanner,
    historiasLink: localConfig.historiasLink,
    subeVideo: localConfig.subeVideo,
    maxSizeVideo: localConfig.maxSizeVideo,
    maxDurationVideo: localConfig.maxDurationVideo,
    estadisticasEnabled: localConfig.estadisticasEnabled,
    whppSoporte: localConfig.whppSoporte
  }
}

export default useLocal
